/**
 * Join class names, dropping anything falsy.
 *
 *   cx("btn", isPrimary && "btn-primary", className)
 *
 * Five lines instead of a `clsx` dependency — this is all we ever needed from it.
 * Note it does NOT de-duplicate conflicting Tailwind utilities (no tailwind-merge
 * behaviour): put the caller's `className` last so it wins by source order, and
 * keep component defaults minimal enough not to fight it.
 */
export function cx(...parts) {
    return parts.filter(Boolean).join(" ");
}
